import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const EmptyState = ({ icon, title, description, action }) => (
    <Stack alignItems="center" spacing={2} sx={{ py: { xs: 6, md: 10 }, textAlign: "center" }}>
        {icon && (
            <Box
                sx={(theme) => ({
                    width: 72,
                    height: 72,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    color: "primary.main",
                    "& > *": { fontSize: 32 },
                })}
            >
                {icon}
            </Box>
        )}
        <Box>
            <Typography variant="h6" sx={{ mb: 0.5 }}>
                {title}
            </Typography>
            {description && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ maxWidth: 420, mx: "auto" }}
                >
                    {description}
                </Typography>
            )}
        </Box>
        {action}
    </Stack>
);

export default EmptyState;